import { styled } from "@mui/material/styles";

import ResponsiveImage from "components/ResponsiveImage/ResponsiveImage";

export const Root = styled("div")({
  position: "relative",
  zIndex: 0,
});

export const StyledResponsiveImage = styled(ResponsiveImage)(({ theme, clickable }) => ({
  marginBottom: 10,
  maxWidth: 56,
  display: "block",
  [theme.breakpoints.up("mobile")]: {
    maxWidth: 86,
  },
  fill: theme.palette.relatives.default.background,
  ...(clickable && {
    cursor: "pointer",
  }),
}));
